module.exports = __webpack_public_path__ + "static/media/back-to-mintpro.d14ae7ed.svg";